import { render, staticRenderFns } from "./metricTypeFilterPopup.vue?vue&type=template&id=4d8fffb4&scoped=true&"
import script from "./metricTypeFilterPopup.vue?vue&type=script&lang=js&"
export * from "./metricTypeFilterPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8fffb4",
  null
  
)

export default component.exports